export default __webpack_public_path__ + "static/comments-teaser-6d9c0069d9114cdea5c27214b670f16c.jpg";